import React from "react";

export const LandingElizaFormIntroHeader = () => {
  return (
    <div className="h-[var(--header-height)] ">
      <div className="h-full w-full  flex form-container gap-3 items-center justify-center">
        <img
          src={"/assets/heart_logo.png"}
          alt="heart logo icon"
          className="size-12"
        />
        <h1 className="text-2xl font-bold">Nectar AI</h1>
      </div>
    </div>
  );
};
